import SlsTemplateImagemClient from '@/api/SistemaDKP/sls-template-imagem.client';
import { resolveImagemUrl } from '@/utils/imagemUrl';

const templateImagem = new SlsTemplateImagemClient();
export default {
  namespaced: true,
  state: () => ({
    imagensDeletadas: [],
    showLoading: false,
    formConfigImagem: {
      exibe_cores: false,
      imagem_principal: false,
      ordem: null,
      cdn_cor: null,
      cdn_embalag: null,
    },
    copyCurrentTemplateImagem: {
      imagens: [],
    },
    currentTemplateImagem: {
      log_img_id: null,
      familia_comercial_id: null,
      cod_marca: null,
      cdn_cor: null,
      exibe_cores: null,
      imagem_principal: null,
      caminho: null,
      categoria: null,
      ordem: null,
      descricao: null,
      caracteristica: null,
      composicao: null,
      beneficios: null,
      indicacoes: null,
      cdn_embalag: null,
      imagens: [],
    },
    templateImagems: [],
    filters: {
      page: 1,
      perPage: 10,
      sortBy: 'log_img_id',
      sortDesc: null,
      total: 0,
    },
    optionsMarcas: [],
    optionsReferencias: [],
    optionsEmbalagens: [],
    isLoading: false,
  }),
  mutations: {
    RESET_FIELDS(state) {
      state.currentTemplateImagem = {
        log_img_id: null,
        familia_comercial_id: null,
        cod_marca: null,
        cdn_cor: null,
        exibe_cores: null,
        imagem_principal: null,
        caminho: null,
        categoria: null,
        ordem: null,
        descricao: null,
        caracteristica: null,
        composicao: null,
        beneficios: null,
        indicacoes: null,
        cdn_embalag: null,
        imagens: [],
      };
      state.copyCurrentTemplateImagem = {
        imagens: [],
      };
    },
    setShowLoading(state, payload) {
      state.showLoading = payload;
    },
    setImagensCurrentTemplateImagem(state, imagens) {
      state.currentTemplateImagem.imagens = imagens;
    },
    updateImagem(state, { index, imagem }) {
      const { imagens } = state.currentTemplateImagem;
      imagens[index] = {
        ...imagem,
        caminho: typeof imagem.caminho === 'object' ? imagem.caminho_base64 : imagem.caminho,
        cdn_embalag: typeof imagem.des_embalag === 'object' ? imagem.des_embalag.cdn_embalag : imagem.cdn_embalag,
        des_embalag: typeof imagem.des_embalag === 'object' ? imagem.des_embalag.des_embalag : imagem.des_embalag,
        des_marca: state.optionsMarcas.find((m) => m.cod_marca === state.currentTemplateImagem.cod_marca).des_marca,
      };
      state.currentTemplateImagem.imagens = JSON.parse(JSON.stringify(imagens));
    },
    addImagem(state, imagem) {
      state.currentTemplateImagem.imagens.push({
        ...imagem,
        cdn_embalag: typeof imagem.des_embalag === 'object' ? imagem.des_embalag.cdn_embalag : imagem.cdn_embalag,
        des_embalag: typeof imagem.des_embalag === 'object' ? imagem.des_embalag.des_embalag : imagem.des_embalag,
        des_marca: state.optionsMarcas.find((m) => m.cod_marca === state.currentTemplateImagem.cod_marca).des_marca,
      });
    },
    setFormConfigImagem(state, payload) {
      state.formConfigImagem = payload;
    },
    setTemplateImagem(state, templateImagems) {
      state.templateImagems = templateImagems;
    },
    setOptionsReferencias(state, payload) {
      const items = Array.isArray(payload) ? payload : [];
      const seen = new Set();
      state.optionsReferencias = items.filter((item) => {
        const key = item.familia_comercial_id ?? item.value ?? item.descricao ?? JSON.stringify(item);
        if (seen.has(key)) {
          return false;
        }
        seen.add(key);
        return true;
      });
    },
    setFilters(state, payload) {
      state.filters = payload;
    },
    setOptionsMarcas(state, payload) {
      state.optionsMarcas = payload;
    },
    setIsLoading(state, payload) {
      state.isLoading = payload;
    },
    addOfUpdateTemplateImagem(state, imagemHome) {
      const imageAlterado = state.currentTemplateImagem.imagens;
      const index = imageAlterado.findIndex((i) => i.log_img_id === imagemHome.log_img_id);
      if (index === -1) {
        imageAlterado.push(imagemHome);
      } else {
        imageAlterado[index] = imagemHome;
      }

      if (state.copyCurrentTemplateImagem) {
        state.copyCurrentTemplateImagem.imagens = JSON.parse(JSON.stringify(imageAlterado));
      } else {
        console.error('Erro: copyCurrentTemplateImagem está null.');
      }
    },
    setCurrentTemplateImagem(state, imagemHome) {
      state.copyCurrentTemplateImagem = { ...imagemHome };
      state.currentTemplateImagem = {
        ...imagemHome,
        caminho: null,
        caminho_catalogo: null,
        caminho_img_cabec_marcas: null,
        caminho_img_footer_principal: null,
        caminho_img_footer_secundaria: null,
      };
    },
    deleteTemplateImagem(state, id) {
      const index = state.templateImagems.findIndex((i) => i.log_img_id === id);
      state.templateImagems.splice(index, 1);
    },
    resetCurrentTemplateImagem(state) {
      state.currentTemplateImagem = {
        log_img_id: null,
        familia_comercial_id: null,
        cod_marca: null,
        cdn_cor: null,
        exibe_cores: null,
        imagem_principal: null,
        caminho: null,
        categoria: null,
        ordem: null,
        descricao: null,
        caracteristica: null,
        composicao: null,
        beneficios: null,
        indicacoes: null,
        cdn_embalag: null,
      };
      state.copyCurrentTemplateImagem = {
        log_img_id: null,
        familia_comercial_id: null,
        cod_marca: null,
        cdn_cor: null,
        exibe_cores: null,
        imagem_principal: null,
        caminho: null,
        categoria: null,
        ordem: null,
        descricao: null,
        caracteristica: null,
        composicao: null,
        beneficios: null,
        indicacoes: null,
        cdn_embalag: null,
      };
    },
    initImagensDeletadas(state) {
      state.imagensDeletadas = [];
    },
    addImagemDeletada(state, imageId) {
      if (!state.imagensDeletadas.includes(imageId)) {
        state.imagensDeletadas.push(imageId);
      }
    },
    clearImagensDeletadas(state) {
      state.currentTemplateImagem.imagensDeletadas = [];
    },
  },
  getters: {
    getShowLoading(state) {
      return state.showLoading;
    },
    getImagensCurrentTemplateImagem(state) {
      return state.currentTemplateImagem.imagens;
    },
    getIsValidCurrentCofigImagem(state) {
      return state.currentTemplateImagem.exibe_cores !== null
                && state.currentTemplateImagem.imagem_principal !== null
                && state.currentTemplateImagem.ordem !== null
                && state.currentTemplateImagem.cdn_cor !== null
                && state.currentTemplateImagem.cdn_embalag !== null;
    },
    getTemplateImagem(state) {
      state.templateImagems.imagens = state.templateImagems.imagens.sort((a, b) => {
        if (a.ordem > b.ordem) {
          return 1;
        }
        if (a.ordem < b.ordem) {
          return -1;
        }
        return 0;
      });
      return state.templateImagems;
    },
    getTemplateImagemEdit(state) {
      return state.currentTemplateImagem;
    },
    getCurrentTemplateImagem(state) {
      return state.currentTemplateImagem;
    },
    getCopyCurrentTemplateImagem(state) {
      return state.copyCurrentTemplateImagem;
    },
    getOptionsReferencias(state) {
      return state.optionsReferencias;
    },
    getFilters(state) {
      return state.filters;
    },
    getIsLoading(state) {
      return state.isLoading;
    },
    getOptionsMarcas(state) {
      state.optionsMarcas.push({ cod_marca: null, des_marca: 'Selecione uma marca' });
      return state.optionsMarcas
        .sort((a, b) => {
          if (a.des_marca === 'Selecione uma marca') {
            return -1;
          }
          if (a.cod_marca > b.cod_marca) {
            return -1;
          }
          if (a.cod_marca < b.cod_marca) {
            return 1;
          }
          return 0;
        })
        .map((m) => ({ text: m.des_marca, value: m.cod_marca }));
    },
    getIsAlteracao(state) {
      return JSON.stringify(state.currentTemplateImagem) !== JSON.stringify(state.copyCurrentTemplateImagem);
    },
    getImagensDeletadas: (state) => state.imagensDeletadas,
  },
  actions: {
    async findAll(ctx, queryParams, options) {
      const { data, ...paginations } = await templateImagem.getTemplateImagem(queryParams);
      const normalizedData = Array.isArray(data)
        ? data.map((item) => ({
          ...item,
          caminho: resolveImagemUrl(item.caminho),
          imagens: Array.isArray(item.imagens)
            ? item.imagens.map((imagem) => ({
              ...imagem,
              caminho: resolveImagemUrl(imagem.caminho),
            }))
            : item.imagens,
        }))
        : data;
      ctx.commit('setTemplateImagem', normalizedData);
      ctx.commit('setFilters', {
        ...ctx.getters.getFilters,
        ...paginations,
      });
      return Promise.resolve({
        data: normalizedData,
        paginations,
      });
    },
    resetFields({ commit }) {
      commit('RESET_FIELDS');
    },
  },
};
